<template lang='pug'>
  i.svg-icon.svg-icon-search
    svg(
      :fill='color'
      :width='`${size}px`'
      :height='`${size}px`'
      viewBox='0 0 100 100'
    )
      path(d='M93.219,84.117l-18.91-18.918c4.594-6.392,7.122-14.031,7.122-22.076c0-10.13-3.944-19.657-11.116-26.826 C63.154,9.131,53.621,5.18,43.485,5.18c-10.135,0-19.666,3.942-26.832,11.117C9.491,23.459,5.542,32.991,5.542,43.123 c0,10.135,3.945,19.664,11.111,26.832c7.166,7.166,16.694,11.12,26.832,11.12c8.038,0,15.673-2.517,22.073-7.126l18.915,18.916 c1.211,1.209,2.788,1.813,4.374,1.813s3.166-0.604,4.371-1.813C95.636,90.445,95.636,86.533,93.219,84.117z M25.405,61.203 c-4.831-4.83-7.489-11.256-7.489-18.083c0-6.827,2.658-13.247,7.489-18.077c4.83-4.833,11.25-7.492,18.08-7.492 c6.831,0,13.251,2.658,18.08,7.492c4.831,4.831,7.492,11.253,7.492,18.081s-2.659,13.25-7.492,18.083s-11.246,7.489-18.08,7.489 C36.652,68.695,30.229,66.034,25.405,61.203z')

</template>

<script>
export default {

  props: {
    size: {
      type: Number,
      default: 20,
    },
    color: {
      type: String,
      default: '#333',
    },
  },

}
</script>